var _ellipse, _ellipse2, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgDispatchCriteriaWorkloadActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.6965,
    cy: 30,
    rx: 30.3166,
    ry: 30,
    fill: "#FFD177",
    fillOpacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.6965,
    cy: 29.5257,
    rx: 17.0531,
    ry: 17.1429,
    fill: "#FFB508"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6977 21.9062V29.7702L35.9072 35.2396",
    stroke: "#FFEDD8",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.9684,
    y: 14.5273,
    width: 1.46169,
    height: 2.818,
    fill: "#FFE79D",
    stroke: "#FFE79D",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9684,
    y: 41.7109,
    width: 1.46169,
    height: 2.818,
    fill: "#FFE79D",
    stroke: "#FFE79D",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.6201,
    y: 28.8242,
    width: 1.409,
    height: 2.92339,
    transform: "rotate(90 45.6201 28.8242)",
    fill: "#FFE79D",
    stroke: "#FFE79D",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.409,
    height: 2.92339,
    transform: "matrix(4.41713e-08 1 1 -4.32562e-08 15.7664 28.8242)",
    fill: "#FFE79D",
    stroke: "#FFE79D",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43559,
    height: 2.87118,
    transform: "matrix(0.719965 0.694011 -0.719965 0.694011 41.2493 18.7578)",
    fill: "#FFE79D",
    stroke: "#FFE79D",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43559,
    height: 2.87118,
    transform: "matrix(-0.719965 0.694011 0.719965 0.694011 20.1372 18.7578)",
    fill: "#FFE79D",
    stroke: "#FFE79D",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43559,
    height: 2.87118,
    transform: "matrix(-0.719964 0.694012 0.719964 0.694012 39.701 38.1484)",
    fill: "#FFE79D",
    stroke: "#FFE79D",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43559,
    height: 2.87118,
    transform: "matrix(0.719965 0.694011 -0.719965 0.694011 21.6847 38.1484)",
    fill: "#FFE79D",
    stroke: "#FFE79D",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDispatchCriteriaWorkloadActive);
export default __webpack_public_path__ + "static/media/img_dispatch_criteria_workload_active.7c92a338068d0b4e70c07af6219ea5a0.svg";
export { ForwardRef as ReactComponent };